import { Component, Inject, OnInit } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirm-update-document-dialog',
  templateUrl: './confirm-update-document-dialog.component.html',
  styleUrls: ['./confirm-update-document-dialog.component.scss']
})
export class ConfirmUpdateDocumentDialogComponent implements OnInit {
  showModal: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmUpdateDocumentDialogComponent>,
    private generalService: GeneralService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
  }

  acceptNotify() {
    const sendDta = {
      user_id: this.data.userId,
      idecatalu: this.data.idecatalu,
    };
    this.generalService.acceptNotificationDocs(sendDta).subscribe();

    this.dialogRef.close(true)
  }

  openPdfInNewTab() {
    this.generalService.getRegulationDocument(this.data.business, this.data.nivelId, this.data.idecatalu).subscribe(result => {
      if (!result || !result.success || !result.file) {
        this.toastr.error((result && result.message) || 'No se pudo abrir el reglamento');
        return;
      }
      const binary = atob(result.file);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      const pdfUrl = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
      window.open(pdfUrl, '_blank');
    }, () => {
      this.toastr.error('No se pudo abrir el reglamento');
    });
  }

}
